// Utility Functions
function getElement(id) {
    return document.getElementById(id);
  }
  
  function toggleElementVisibility(id, show) {
    const element = getElement(id);
    if (element) {
      element.classList.toggle("hidden", !show);
    }
  }
  
  function clearTimeouts() {
    if (window.toastTimeout) clearTimeout(window.toastTimeout);
    if (window.toastHideTimeout) clearTimeout(window.toastHideTimeout);
  }
  
  // Toast System
  function insertToastContainer() {
    if (getElement("toast-container")) return;
    
    document.body.insertAdjacentHTML(
      "beforeend",
      `<div id="toast-container" class="toast-container hidden">
        <div id="toast" class="toast">
          <span id="toast-message"></span>
        </div>
      </div>`
    );
  }
  
  function showToast(message, duration = 5000) {
    const container = getElement("toast-container");
    const toast = getElement("toast");
    const messageElement = getElement("toast-message");
  
    if (!container || !toast || !messageElement) return;
  
    clearTimeouts();
    
    toast.classList.remove("slide-out");
    container.classList.remove("hidden");
    messageElement.textContent = message;
  
    window.toastTimeout = setTimeout(() => hideToast(), duration);
  }
  
  function hideToast() {
    const container = getElement("toast-container");
    const toast = getElement("toast");
  
    if (!container || !toast) return;
  
    clearTimeouts();
    toast.classList.add("slide-out");
  
    window.toastHideTimeout = setTimeout(() => {
      container.classList.add("hidden");
      toast.classList.remove("slide-out");
    }, 300);
  }
  
  // Formula Management
  function formatFormula(formula) {
    return Array.isArray(formula) 
      ? formula.map(item => `${item.serumType}: ${item.value}`).join(", ")
      : "";
  }
  
  function showFormulaErrorText() {
    const element = getElement("formula-text");
    if (element?.dataset.formulaLabelError) {
      element.textContent = element.dataset.formulaLabelError;
    }
  }
  
  function setFormulaText(formattedFormula) {
    requestAnimationFrame(() => {
      const element = getElement("formula-text");
      const formulaLabel = element?.dataset.formulaLabel;
      if (element && formulaLabel) {
        element.textContent = `${formulaLabel} : ${formattedFormula}`;
      }
    });
  }
  
  function toggleFormulaContent(show) {
    requestAnimationFrame(() => {
      toggleElementVisibility("formula-block", show);
      toggleElementVisibility("formula-available-info", show);
    });
  }
  
  // Cart Property Management
  function updateCartProperties(form, variantData) {
    const variantInput = form?.querySelector('input[name="id"]');
    if (!variantInput) return;
  
    const existingInput = form.querySelector('input[name="properties[diagnostic_formula]"]');
    const currentVariantId = variantInput.value;
    const formula = variantData[currentVariantId];
  
    if (formula) {
      const formattedFormula = formatFormula(formula);
      
      if (existingInput) {
        existingInput.value = formattedFormula;
      } else {
        const hiddenInput = document.createElement("input");
        Object.assign(hiddenInput, {
          type: "hidden",
          name: "properties[diagnostic_formula]",
          value: formattedFormula
        });
        form.appendChild(hiddenInput);
      }
      
      setFormulaText(formattedFormula);
      toggleFormulaContent(true);
    } else {
      existingInput?.remove();
      toggleFormulaContent(false);
    }
  }
  
  // Variant Selection
  function selectLastVariant() {
    const radios = document.querySelectorAll('variant-picker input[name*="option"]');
    const lastRadio = radios[radios.length - 1];
    
    if (lastRadio) {
      lastRadio.checked = true;
      lastRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
  
  // URL Management
  function extractTokenAndCleanUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    
    if (token && window.history?.replaceState) {
      window.history.replaceState({}, "", window.location.pathname);
    }
    
    return token;
  }
  
  function createDiagnosticResultUrl(token, diagnosticResultBase64) {
    const baseUrl = window.DIAGNOSTIC_CONFIG?.diagnosticResultViewerUrl;
    return baseUrl ? `${baseUrl}?token=${token}&data=${diagnosticResultBase64}` : "";
  }
  
  function setDiagnosticResultButtonHref(href) {
    requestAnimationFrame(() => {
      const button = getElement("result-button");
      if (button) {
        button.href = href;
      }
    });
  }
  
  // API Client
  function makeApiRequest(url, token) {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    });
  }
  
  function fetchDiagnosticData(token) {
    const config = window.DIAGNOSTIC_CONFIG;
    if (!config) return Promise.reject(new Error("Config not available"));
  
    return Promise.all([
      makeApiRequest(config.productRecommendationsUrl, token),
      makeApiRequest(config.diagnosticResultUrl, token)
    ]);
  }
  
  // Data Mapping
  function mapRecommendationsToVariants(recommendations) {
    const mapping = {};
    const variantMapping = window.DIAGNOSTIC_CONFIG?.variantMapping || {};
    
    Object.entries(variantMapping).forEach(([variantId, productType]) => {
      if (recommendations[productType]) {
        mapping[variantId] = recommendations[productType];
      }
    });
    
    return mapping;
  }
  
  // Storage Management
  function setStorageData(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.warn(`Failed to store ${key}:`, e);
    }
  }
  
  function getStorageData(key) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.warn(`Failed to retrieve ${key}:`, e);
      return null;
    }
  }
  
  // Event Management
  function setupFormChangeListener(variantData, href) {
    const variantPicker = document.querySelector("variant-picker");
    const formId = variantPicker?.getAttribute("form-id");
    const addToCartForm = formId ? getElement(formId) : null;
  
    if (addToCartForm) {
      addToCartForm.addEventListener("change", () => {
        updateCartProperties(addToCartForm, variantData);
        setDiagnosticResultButtonHref(href);
      });
    }
  }
  
  // Core Initialization Logic
  function setupDiagnosticInterface(variantData, href) {
    setupFormChangeListener(variantData, href);
    selectLastVariant();
    setDiagnosticResultButtonHref(href);
  }
  
  function showSuccessToast() {
    const toastLabel = getElement("toast-text").dataset.toastLabel;
    showToast(toastLabel);
  }

  function prepareDiagnosticData(recommendations, diagnosticResult, token) {
    const diagnosticResultBase64 = btoa(JSON.stringify(diagnosticResult));
    const href = createDiagnosticResultUrl(token, diagnosticResultBase64);
    const variantData = mapRecommendationsToVariants(recommendations);
    
    return { href, variantData };
  }
  
  // Main Initialization Functions
  function initializeWithCachedData() {
    const recommendations = getStorageData("product_recommendations");
    const diagnosticResult = getStorageData("diagnostic_result");
    const configToken = getStorageData("config_token");
  
    if (recommendations && configToken && diagnosticResult) {
        const { href, variantData } = prepareDiagnosticData(recommendations, diagnosticResult, configToken);
      setupDiagnosticInterface(variantData, href);
    }
  }
  
  function initializeWithFreshData(token) {
    setStorageData("config_token", token);
  
    fetchDiagnosticData(token)
      .then(([recommendations, diagnosticResult]) => {
        setStorageData("product_recommendations", recommendations);
        setStorageData("diagnostic_result", diagnosticResult);
  
        const { href, variantData } = prepareDiagnosticData(recommendations, diagnosticResult, token);
        setupDiagnosticInterface(variantData, href);
        showSuccessToast();
      })
      .catch(error => {
        console.error("Diagnostic error:", error);
        showFormulaErrorText();
      });
  }
  
  function initializeDiagnosticApp() {
    const token = extractTokenAndCleanUrl();
    
    if (token) {
      insertToastContainer();
      initializeWithFreshData(token);
    } else {
      initializeWithCachedData();
    }
  }
  
  // Application Entry Point
  document.addEventListener("DOMContentLoaded", function() {
    if (window.DIAGNOSTIC_CONFIG) {
      initializeDiagnosticApp();
    }
  });